import { Component, Input } from '@angular/core';

@Component({
    selector: 'order-edit-logs',
    templateUrl: './order-edit-logs.html',
    standalone: false
})
export class OrderEditLogsComponent {
  @Input() editLogs: Array<any> = [];
  @Input() editedByName: string = '';
}
